export default "313960063bb4e2b4.png"